import { render, staticRenderFns } from "./EmailView.vue?vue&type=template&id=115b64a1&"
import script from "./EmailView.vue?vue&type=script&lang=js&"
export * from "./EmailView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports